import BaseService from "../CorBase/BaseService";
import BaseFilter from '../CorBase/BaseFilter';

export class PricelistService extends BaseService {
	constructor() {
		super('/Pricelist');
	}

	public deleteList(list: number[]) {
		return this.deleteListWithResourceName(list, 'delete-list')
	}

	public getAllByFilter(filter: PricelistFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class PricelistFilter extends BaseFilter {
	constructor(name?: string | null) {
		super();

		this._name = name;
	}

	private _name?: string | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._name != null ? { Name: this._name } : {})

		);

		return data;
	};
}